import { action, computed, observable } from "mobx";
import { AppStore } from "./AppStore";

class StateStorageImpl {

	@computed get IsLocalStoreSupported(): boolean {
		if ((typeof (Storage) != "undefined") && localStorage)
			return true;
		else
			return false;
	}

	/*----------------------Read, Write and Delete Cookie-------------------*/
	@action private retrieveFromCookie = (name: string) => {
		let nameEQ = name + "=";
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	@action private saveToCookie = (name: string, value: any, days: number) => {
		let expires = "";
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	@action private removeFromCookie = (name: string) => {
		this.saveToCookie(name, "", -1);
	}
	/*----------------------------------------------------------------------*/

	/*----------------------Read, Write and Delete Local Storage------------*/
	@action private retrieveFromLocalStorage = (key: string) => {
		return localStorage.getItem(key);
	}

	@action private saveToLocalStorage = (key: string, value: any) => {
		localStorage.setItem(key, value);
	}

	@action private removeFromLocalStorage = (key: string) => {
		localStorage.removeItem(key);
	}
	/*----------------------------------------------------------------------*/
	/*-----------------Public methods----------------------------------*/
	@action public saveData = (key: string, value: string) => {
		if (this.IsLocalStoreSupported) {
			this.saveToLocalStorage(key, value);
		}
		else {
			this.saveToCookie(key, value, 30);
		}
	}

	@action public getData = (key: string): string => {
		if (this.IsLocalStoreSupported) {
			return this.retrieveFromLocalStorage(key);
		}
		else {
			return this.retrieveFromCookie(key);
		}
	}

	@action public removeData = (key: string) => {
		if (this.IsLocalStoreSupported) {
			this.removeFromLocalStorage(key);
		}
		else {
			this.removeFromCookie(key);
		}
	}
	/*----------------------------------------------------------------------*/
}

export var StateStorage = new StateStorageImpl();
